var map = {
	"./grid/covid-hits-home-13.jpg": "55fe",
	"./grid/covid-hits-home-14.jpg": "b0f8",
	"./intro/covid-hits-home-scrollyimage1-desktop.jpg": "935a",
	"./intro/covid-hits-home-scrollyimage1.jpg": "080d",
	"./intro/covid-hits-home-scrollyimage2-desktop.jpg": "d36c",
	"./intro/covid-hits-home-scrollyimage2.jpg": "8b56",
	"./intro/covid-hits-home-scrollyimage3-desktop.jpg": "b120",
	"./intro/covid-hits-home-scrollyimage3.jpg": "025b",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8453";